exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headerContainer {\n\t--header-height: 30.5rem;\n}\n\n.headerContainer {\n\twidth: 100%;\n\tbackground-color: #1DADFC;\n\theight: var(--header-height);\n\ttext-align: center;\n}\n\n.headerContainer > img {\n\theight: var(--header-height);\n\tpadding: 5rem 0;\n\tmax-width: 95%;\n}\n", ""]);

// exports
